declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    LiveTex: any;
  }
}

export function init() {
  window.site?.elcEvents?.addListener('tealium:livetex-loaded', function () {
    const LiveTex = window.LiveTex;

    function trackLiveTexEvent(data) {
      site.track.evtLink({
        event_name: 'liveTex',
        event_category: 'Live Chat Interaction',
        event_action: data?.event || '',
        event_label: window.location.pathname
      });
    }

    LiveTex.addEventListener(LiveTex.Event.WELCOME_WINDOW_SHOWN, trackLiveTexEvent);
    LiveTex.addEventListener(LiveTex.Event.EMPLOYEE_MESSAGE_SENT, trackLiveTexEvent);
    LiveTex.addEventListener(LiveTex.Event.OFFLINE_MESSAGE_SENT, trackLiveTexEvent);
    LiveTex.addEventListener(LiveTex.Event.CONVERSATION_STARTED, trackLiveTexEvent);
    LiveTex.addEventListener(LiveTex.Event.CALL_STARTED, trackLiveTexEvent);
    LiveTex.addEventListener(LiveTex.Event.X_WINDOW_SHOWN, trackLiveTexEvent);
    LiveTex.addEventListener(LiveTex.Event.INVITATION_WINDOW_SHOWN, trackLiveTexEvent);
    LiveTex.addEventListener(LiveTex.Event.INVITATION_WINDOW_CLOSE, trackLiveTexEvent);
    LiveTex.addEventListener(LiveTex.Event.CALLBACK_SENT, trackLiveTexEvent);
  });
}
